import React from "react";
import { styled } from "@linaria/react";
import t from "../../../i18n";
import type { Project } from "../../../api/useProjects";
import { FlaskFill } from "@ui/IconV2/react";
import TooltipV2 from "@ui/TooltipV2";
import OverlayWrapper from "@ui/TooltipV2/OverlayWrapper";

interface P {
  project: Project;
}

const StyledLab = styled(FlaskFill)`
  display: flex;
  align-items: baseline;
  width: 14px;
  height: 14px;
`;

const AppHeaderIcon = ({ project }: P) => (
  <>
    {project.draft ? (
      <TooltipV2
        placement="bottom"
        overlay={<OverlayWrapper text={t("commons.tooltip.research")} />}
      >
        <span>
          <StyledLab />
        </span>
      </TooltipV2>
    ) : null}
  </>
);
const Wrapper = ({ project }: P) => (
  <React.Suspense>
    <AppHeaderIcon project={project} />
  </React.Suspense>
);

export default Wrapper;
